import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {BaseService} from "./BaseService";
import {environment} from "../../environments/environment";
import {AuthStateService} from "./auth/auth-state.service";

@Injectable({
  providedIn: 'root'
})
export class RouteGuardService extends BaseService {

  private authState = inject(AuthStateService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (environment.bypassLogin) {
      return true;
    }
    return this.authState.isLoggedIn() ? true : this.router.createUrlTree(['']);
  }

  cleanupServiceFields(): void {
    // doNothing
  }
}
